// Mirrors functions/src/contracts/placeholders.ts
import moment from 'moment';
export const CONTRACT_PLACEHOLDERS = [
    { key: 'name', title: 'Jméno' },
    { key: 'surname', title: 'Příjmení' },
    { key: 'email', title: 'Email' },
    { key: 'phone', title: 'Telefon' },
    { key: 'address', title: 'Adresa' },
    { key: 'birthNumber', title: 'Rodné číslo' },
    { key: 'ico', title: 'IČO' },
    { key: 'bankAccount', title: 'Číslo účtu' },
    { key: 'contractDate', title: 'Datum podpisu' },
    { key: 'seasonYear', title: 'Sezóna' },
    { key: 'validFrom', title: 'Platnost od' },
    { key: 'validTo', title: 'Platnost do' },
    { key: 'gradeTitle', title: 'Platová třída' },
    { key: 'rateIndividual', title: 'Sazba individuál' },
    { key: 'rateWex', title: 'Sazba WEX' },
    { key: 'rateKidSchool', title: 'Sazba školka' },
    { key: 'rateStorno', title: 'Sazba storno' },
    { key: 'signatureInstructor', title: 'Podpis instruktora' },
    { key: 'signatureAuthority', title: 'Podpis školy' },
];
export const SIGNATURE_PLACEHOLDERS = ['signatureInstructor', 'signatureAuthority'];
// contractDate / seasonYear are added by the caller
export const SAMPLE_PLACEHOLDER_VALUES = {
    name: 'Jan',
    surname: 'Novák',
    email: 'jan.novak@example.cz',
    phone: '777123456',
    address: 'Horní 12, 500 01 Hradec Králové',
    birthNumber: '900101/0007',
    ico: '12345678',
    bankAccount: '123456789/0100',
    validFrom: '1. 12. 2026',
    validTo: '30. 4. 2027',
    gradeTitle: 'Instruktor I',
    rateIndividual: '250',
    rateWex: '180',
    rateKidSchool: '120',
    rateStorno: '80',
};
const PLACEHOLDER_RE = /\{\{\s*(\w+)\s*\}\}/g;
/** Template validity bounds are stored as YYYY-MM-DD. */
export function formatContractDate(value) {
    if (!value)
        return '';
    const [year, month, day] = value.split('-');
    return `${Number(day)}. ${Number(month)}. ${year}`;
}
export function usedPlaceholders(bodyHtml) {
    return new Set([...bodyHtml.matchAll(PLACEHOLDER_RE)].map(match => match[1]));
}
export function findUnknownPlaceholders(bodyHtml) {
    const known = CONTRACT_PLACEHOLDERS.map(p => p.key);
    const unknown = new Set();
    let match;
    while ((match = PLACEHOLDER_RE.exec(bodyHtml)) !== null) {
        if (!known.includes(match[1]))
            unknown.add(match[1]);
    }
    return [...unknown];
}
/** Mirrors buildPlaceholderValues in functions/src/contracts/placeholders.ts. */
export function buildPlaceholderValues(instructor, grade, season, period = {}) {
    return {
        name: instructor.name ?? '',
        surname: instructor.surname ?? '',
        email: instructor.email ?? '',
        phone: instructor.phone == null ? '' : String(instructor.phone),
        address: instructor.address ?? '',
        birthNumber: instructor.birthNumber ?? '',
        ico: instructor.ico ?? '',
        bankAccount: instructor.bankAccount ?? '',
        contractDate: moment().format('D. M. YYYY'),
        seasonYear: season,
        validFrom: formatContractDate(period.validFrom),
        validTo: formatContractDate(period.validTo),
        gradeTitle: grade?.title ?? '',
        rateIndividual: grade?.individual == null ? '' : String(grade.individual),
        rateWex: grade?.wex == null ? '' : String(grade.wex),
        rateKidSchool: grade?.kidSchool == null ? '' : String(grade.kidSchool),
        rateStorno: grade?.storno == null ? '' : String(grade.storno),
    };
}
function escapeHtml(value) {
    return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}
export function renderPreview(bodyHtml, values) {
    return bodyHtml.replace(PLACEHOLDER_RE, (token, key) => {
        if (SIGNATURE_PLACEHOLDERS.includes(key)) {
            return `<span class="contract-signature-spot" data-placeholder="${key}">[podpis]</span><br><span class="contract-signature-date">Podepsáno d. m. rrrr hh:mm</span>`;
        }
        return escapeHtml(values[key] ?? token);
    });
}
